<!--索引检查器dialog-->
<template>
    <el-dialog width="900px" center title="提示" :visible.sync="visible">
        <div class="txt">亚马逊网站有限制，在首次访问时，需要用户点击后，才可以进行数据抓取分析工作。</div>
        <div class="txt">具体操作步骤如下：</div>
        <div class="txt">1.点击<a :href="errorUrl" target="_blank" class="blankHref">链接</a>跳转到新页面</div>
        <div class="txt">2.根据图片标记点击页面即可</div>
        <div class="txt">3.关闭弹窗，再次点击<b>检查关键字</b>按钮</div>
        <img src="../../assets/tip.png" style="width:850px; height: 150px;margin:10px auto;">

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="visible = false">关 闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "indexCheckTipDialog",
        data(){
            return {
                visible:false,
                errorUrl: ''
            }
        },
        methods:{
            openDialog(url) {
              this.errorUrl = url
              this.visible = true
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.$emit('close-callback', isshow)
            },
        }
    }
</script>

<style scoped>
    .txt {
        font-size: 18px;
        margin-bottom: 10px;
    }
    .blankHref {
        color: blue;
        text-decoration: underline;
    }
</style>
